export const CommentTypes = {
    FirstCommentWithAttachment: 1,
    Regular: 2
};